// @flow

export const NO_PROGRAM = 'None';
